const languages: any = {
  ja: {
    // Button
    buttonConfirm: '確認',
    buttonCancel: 'キャンセル',
    buttonGift: 'ギフト',
    // Gift
    giftPopupConfirmTitle: 'ギフト贈与確認',
    giftPopupConfirmDescription: '本当にギフトを贈与しますか。',
    donateFailed:'贈与に失敗しました。',
    donateSuccess:'{0}ポイントのギフトを贈与しました。',
    notEnoughMoney:'残高が足りません。',
    donationNotify: "{0}ポイントが贈与されました。",
    // Chat
    sendMessage: 'メッセージを送ろう',
    // Close stream
    closeStreamPopupConfirmTitle: 'ライブ終了確認',
    closeStreamPopupConfirmDescription: '本当にライブを終了しますか。',
  },
  en: {
    // Button
    buttonConfirm: 'Confirm',
    buttonCancel: 'Cancel',
    buttonGift: 'Gift',
    // Gift
    giftPopupConfirmTitle: 'Send gift confirm',
    giftPopupConfirmDescription: 'Are you sure you want to send it?',
    donateFailed:'Donate failed',
    donateSuccess: 'Donate {0} successfully',
    notEnoughMoney:'Not enough money',
    donationNotify: 'Donated {0}',
    // Chat
    sendMessage: 'Send message',
    // Close stream
    closeStreamPopupConfirmTitle: 'Close live confirm',
    closeStreamPopupConfirmDescription: 'Do you want to close the livestream?',
  }
};

export default languages;
